import React, { useEffect } from 'react';
import Layout from '@common/Layout';
import {
  PageBlockUnion,
  useHomeLazyQuery,
  useHomeSkeletonQuery,
} from '@common/Providers/GraphqlProvider/generated';
import { TypeNamePageBlocks } from '@utils/constants';

import PublicBlockRegistry from '@/components/blocks/PublicBlockRegistry';
import PublicBlockSkeletonRegistry from '@/components/blocks/PublicBlockSkeletonRegistry';

const AVAILABLE_BLOCKS: string[] = [
  TypeNamePageBlocks.PageSliderBlock,
  TypeNamePageBlocks.PageCabinetBlock,
  TypeNamePageBlocks.PageTaxesBlock,
  TypeNamePageBlocks.PageNewsletterBlock,
  TypeNamePageBlocks.PageProceduresBlock,
  TypeNamePageBlocks.PageRegulationsBlock,
  TypeNamePageBlocks.PageEventsBlock,
  TypeNamePageBlocks.PageSocialNetworksBlock,
  TypeNamePageBlocks.PageQuickAccessBar,
  TypeNamePageBlocks.PageCustomBlock,
  TypeNamePageBlocks.PageSnsBlock,
  TypeNamePageBlocks.PageAlertsBlock,
  TypeNamePageBlocks.PageMapBlock,
];

const BlockComponent = ({ block }: { block: PageBlockUnion }) => {
  if (!block.__typename || !AVAILABLE_BLOCKS.includes(block.__typename)) {
    return null;
  }
  return <PublicBlockRegistry block={block as PageBlockUnion} />;
};

const Home = () => {
  const { data: skeletonData, loading: skeletonLoading } = useHomeSkeletonQuery();

  const [loadHome, { data: data, loading: loading }] = useHomeLazyQuery();

  useEffect(() => {
    if (!skeletonLoading && skeletonData?.mainPage) {
      loadHome();
    }
  }, [skeletonLoading, skeletonData, loadHome]);

  // while skeleton not loaded, don't render anything
  if (!skeletonData?.mainPage) return <></>;

  // show skeleton placeholders using skeleton query
  if (skeletonData && !data) {
    return (
      <Layout>
        {[...skeletonData.mainPage]
          .sort((a: any, b: any) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0))
          .map((block, i) => {
            return <PublicBlockSkeletonRegistry key={i} block={block as PageBlockUnion} />;
          })}
      </Layout>
    );
  }

  if (loading || !data?.mainPage) return <></>;

  return (
    <Layout>
      {[...data.mainPage]
        .sort((a: any, b: any) => a.orderIndex - b.orderIndex)
        .map((block, i) => {
          return <BlockComponent key={i} block={block as PageBlockUnion} />;
        })}
    </Layout>
  );
};

export default Home;
